import styled from 'styled-components';
import {Space} from 'antd';
import AntdModal from '../../../AntdModal';

const StyledSelectCardTypeModal = styled(AntdModal)`
  .ant-modal-content > div {
    &.ant-modal-body {
      padding: 50px 40px;
    }
  }
  
  .ant-modal-footer {
    margin-top: 0;
  }
`;

const StyledSelectCardTypeModalRadio = styled(Space)`
  position: relative;
  width: 212px;
  
  h3, p {
    margin: 0;
    padding: 0;
  }
  
  h3 {
    color: ${props => props.theme.colors.neutral_10};
    font-size: 14px;
    font-weight: 700;
    line-height: 22px;
  }
  
  p {
    color: ${props => props.theme.colors.neutral_7};
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
  }
  
  .ant-radio-wrapper {
    margin-inline-end: 0;
    position: absolute;
    right: 21px;
    top: 25px;
  }
  
  .ant-radio {
    .ant-radio-inner {
      border: none;
      height: 22px;
      width: 22px;
    }
    
    &.ant-radio-checked {
      .ant-radio-inner {
        background-color: ${props => props.theme.colors.neutral_1};
        
        &:after {
          background-color: ${props => props.color || '#40b0d5'};
          height: 22px;
          margin-block-start: -11px;
          margin-inline-start: -11px;
          width: 22px;
        }
      }
    }
  }
  
`;

const StyledSelectCardTypeModalRadioContent = styled.div`
  display: flex;
  position: relative;
  transition: .2s ease-in-out;
  
  &.checked,
  &:hover {
    cursor: pointer;
  }
  
  &:hover {
    opacity: 0.85;
  }
  
  & > .ant-space-item {
    .ant-radio-wrapper {
      margin: 0;
    }
  }
  
  svg {
    height: 312px;
    width: 212px;
  }
`;

export {
  StyledSelectCardTypeModal,
  StyledSelectCardTypeModalRadio,
  StyledSelectCardTypeModalRadioContent
}